/** @jsx jsx */
import { jsx } from '@emotion/react';

const getStyles = (scale: number) => ({
  left: {
    left: 0,
    transform: `scale(${scale})`,
    transformOrigin: 'top left',
  },
  right: {
    right: 0,
    transform: `scale(${-1 * scale}, ${scale}) translateX(100%)`,
    transformOrigin: 'top right',
  },
});

const ConfettiSVG = ({ side }: { side: 'left' | 'right' }) => (
  <svg
    role="presentation"
    css={{
      position: 'absolute',
      top: 0,
      ...getStyles(0.6)[side],
    }}
    width="541"
    height="140"
    viewBox="0 0 541 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.63 20.0884C176.63 18.2722 178.096 16.7999 179.903 16.7999C181.711 16.7999 183.176 18.2722 183.176 20.0884C183.176 21.9046 181.711 23.3768 179.903 23.3768C178.096 23.3768 176.63 21.9046 176.63 20.0884Z"
        fill="var(--cds-color-blue-50)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.7563 23.7981C49.7563 21.9819 51.2216 20.5097 53.0293 20.5097C54.8369 20.5097 56.3022 21.9819 56.3022 23.7981C56.3022 25.6143 54.8369 27.0865 53.0293 27.0865C51.2216 27.0865 49.7563 25.6143 49.7563 23.7981Z"
        fill="var(--cds-color-blue-50)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.649 0.548727L145.641 5.65302L138.088 8.7653L130.473 11.7001L131.91 3.63345L133.533 -4.40477L139.649 0.548727Z"
        stroke="var(--cds-color-green-100)"
        strokeWidth="4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M352.562 1.39794C352.562 -1.06304 354.547 -3.05794 356.997 -3.05794C359.446 -3.05794 361.432 -1.06304 361.432 1.39794C361.432 3.85892 359.446 5.85382 356.997 5.85382C354.547 5.85382 352.562 3.85892 352.562 1.39794Z"
        fill="var(--cds-color-red-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.427 23.5198L110.289 27.922L103.135 31.695L103.427 23.5198Z"
        fill="var(--cds-color-red-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.9917 101.92L65.8541 106.322L58.7004 110.095L58.9917 101.92Z"
        fill="var(--cds-color-blue-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.85498 40.2405L5.71297 48.1327L-6.05353e-05 42.3926L7.85498 40.2405Z"
        fill="var(--cds-color-red-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.964 40.2401L139.822 48.1323L134.109 42.3922L141.964 40.2401Z"
        fill="var(--cds-color-red-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5588 77.9916L40.2032 84.7105L32.155 85.4228L35.5588 77.9916Z"
        fill="var(--cds-color-red-400)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M459.41 15.7869C459.41 14.5532 460.405 13.5532 461.633 13.5532C462.861 13.5532 463.856 14.5532 463.856 15.7869C463.856 17.0206 462.861 18.0207 461.633 18.0207C460.405 18.0207 459.41 17.0206 459.41 15.7869Z"
        fill="var(--cds-color-blue-50)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.3165 62.7074C83.3165 60.24 85.3072 58.2399 87.763 58.2399C90.2188 58.2399 92.2095 60.24 92.2095 62.7074C92.2095 65.1748 90.2188 67.1749 87.763 67.1749C85.3072 67.1749 83.3165 65.1748 83.3165 62.7074Z"
        fill="var(--cds-color-red-300)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M305.334 6.4787C305.334 4.01129 307.325 2.01119 309.781 2.01119C312.236 2.01119 314.227 4.01129 314.227 6.4787C314.227 8.9461 312.236 10.9462 309.781 10.9462C307.325 10.9462 305.334 8.9461 305.334 6.4787Z"
        fill="var(--cds-color-red-300)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M527.302 -2.70599L529.892 1.85515L520.921 7.12254L518.331 2.56069L527.302 -2.70599Z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M418.938 5.36106C418.938 8.3221 416.548 10.7221 413.602 10.7221C410.655 10.7221 408.266 8.3221 408.266 5.36106C408.266 2.40002 410.655 5.26788e-05 413.602 5.29375e-05C416.548 5.31961e-05 418.938 2.40002 418.938 5.36106Z"
        stroke="var(--cds-color-blue-400)"
        strokeWidth="4.268"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.836 102.527L88.3373 97.9311L97.687 91.0514L101.187 95.6474L91.836 102.527Z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M246.932 4.04137L245.483 9.64152L234.33 6.47809L235.778 0.877325L246.932 4.04137Z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4568 131.481L19.1297 126.356L29.2805 131.974L26.6079 137.1L16.4568 131.481Z"
        fill="var(--cds-color-yellow-200)"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="541" height="140" fill="white" transform="translate(541 140) rotate(-180)" />
      </clipPath>
    </defs>
  </svg>
);

export default ConfettiSVG;
